namespace advisorop.domains {
    export class IWorkflowShape {
        id?: string;
        type?: string;
        text?: any;

        // Supplemental fields
        aoId?: number;
        name?: string;
        description?: string;
        claimRoles?: string;
        claimAllowedAllTimes?: boolean;
        autoComplete?: boolean;
        biDictionaryElement?: domains.BIDictionary;
        biCompareOperatorPositive?: domains.ComparisonOperator;
        aoAutomatedTask?: domains.AOAutomatedTask;

        stepPermissionedRole?: domains.WorkflowStepPermission;

        step?: domains.IWorkflowStep; // only used when sending back workflow instances
    }

    export class IWorkflowConnector {
        id?: string;
        from?: string;
        to?: string;
        text?: any;

        // Supplemental fields
        aoId?: number;
        description?: string;
        positivityIndicator?: domains.PositivityIndicator;
        pathTaken?: domains.IWorkflowPathTaken; // only used when sending back workflow instances
    }

    export class IWorkflowDiagram {
        shapes?: IWorkflowShape[];
        connectors?: IWorkflowConnector[];
    }

    export class IWorkflowTaskSummaryInfo {
        workflowMasterId?: number;
        myClaimed?: number;
        othersInMyTeamClaimed?: number;
        myTeamUnclaimed?: number;
        otherTeamClaimed?: number;
        otherTeamUnclaimed?: number;
}

    export class IWorkflowMaster {
        id?: number;
        advisoryFirmId?: number;
        name?: string;
        description?: string;
        linearWorkflow?: IWorkflowShape[];
        diagram?: IWorkflowDiagram;
        linkToInvestorOrHousehold?: boolean;
        linkToAccount?: boolean;
        linkToValue?: boolean;
        biDictionaryTriggerElement?: domains.BIDictionary;
        biTriggerOperator?: domains.ComparisonOperator;
        biTriggerValue?: number;
        workflowTaskSummaryInfo?: IWorkflowTaskSummaryInfo;
    }

    export class IWorkflowInstance {
        id?: number;
        workflowMasterId?: number;
        description?: string;
        dateCreated?: string;
        accountId?: number;
        accountDesc?: string;
        householdId?: number;
        householdDesc?: string;
        investorId?: number;
        investorDesc?: string;
        biTargetValue?: number;
        notes?: string;
        diagram?: IWorkflowDiagram;
        linearLatestSteps?: IWorkflowShape[];
        priorVisits?: IWorkflowShape[];
        //currentSteps?: string;
    }

    export class IWorkflowStep {
        id?: number;
        workflowInstanceId?: number;
        //shapeId?: WorkflowShapes;
        shapeId?: number;
        visitCounter?: number;
        startDate?: Date;
        endDate?: Date;
        responsibleUserId?: number;
        notes?: string;
        workflowStepStatus?: WorkflowStepStatus;
        responsibleUserName?: string;

        isLatestCompletedStep?: boolean; // populated by client
    }

    export class IWorkflowPathTaken {
        id?: number;
        workflowInstanceId?: number;
        ConnectorId?: number;
        visitCounter?: number;
        notes?: string;
        workflowPathTakenStatus?: WorkflowPathTakenStatus;
    }

}